import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=4b40b010&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=4b40b010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b40b010",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b40b010')) {
      api.createRecord('4b40b010', component.options)
    } else {
      api.reload('4b40b010', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=4b40b010&scoped=true&", function () {
      api.rerender('4b40b010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cS0i7i8aCvJ2/JS/comp/PopupDialog.vue"
export default component.exports